import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import Header from "../components/header"
import Footer from "../components/footer"

import "../assets/scss/main.scss"

import "./index.scss"

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={(data) => {
      return (
        <>
          <Header />
          <main>
            {children}
          </main>
          <Footer />
        </>
      )
    }}
  />
)

export default Layout
